var Cookies=require('js-cookie');/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}var fetchLanguageDocument = function (documentId, clientId, language, version) { return __awaiter(void 0, void 0, void 0, function () {
    var url;
    return __generator(this, function (_a) {
        url = "https://api.storebrand.no/open/content/texts/".concat(documentId, "?version=").concat(version, "&lang=").concat(language);
        return [2, fetch(url, {
                method: "GET",
                headers: { clientId: clientId, Accept: "application/json" },
            }).then(function (response) { return response.json(); })];
    });
}); };
var fetchLanguageDocuments = function (documentIds, clientId, language, version) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2, Promise.all(documentIds.map(function (documentId) {
                return fetchLanguageDocument(documentId, clientId, language, version);
            })).then(function (loadedTranslations) {
                return Object.assign.apply(Object, __spreadArray([{}], loadedTranslations, false));
            })];
    });
}); };var NORWEGIAN_LANGUAGE_FROM_COOKIE = "nb";
function getInitialLanguage() {
    var cookieLanguage = Cookies.get("lang");
    if (cookieLanguage === NORWEGIAN_LANGUAGE_FROM_COOKIE) {
        return "no";
    }
    return cookieLanguage || "no";
}var appConfig = {
    language: getInitialLanguage(),
    documentIds: [],
    clientId: "",
    version: "pending",
};
var setConfig = function (config) {
    Object.assign(appConfig, config);
};
var setLanguage = function (language) {
    Object.assign(appConfig, __assign(__assign({}, appConfig), { language: language }));
};var currentTranslations = {};
var updateTranslations = function (document) {
    var _a;
    var currentLanguage = appConfig.language;
    var updatedTranslations = __assign(__assign({}, currentTranslations), (_a = {}, _a[currentLanguage] = document, _a));
    setTranslations(updatedTranslations);
};
var setTranslations = function (translations) {
    Object.assign(currentTranslations, translations);
};var setInitialConfig = function (_a) {
    var _b = _a.fallback, fallback = _b === void 0 ? {} : _b, _c = _a.language, language = _c === void 0 ? getInitialLanguage() : _c, config = __rest(_a, ["fallback", "language"]);
    setTranslations(fallback);
    setConfig(__assign(__assign({}, config), { language: language }));
};
var init = function (initConfig) { return __awaiter(void 0, void 0, void 0, function () {
    var documentIds, clientId, version, getFallbackTextsForLanguage, fallback, language, document_1, _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                setInitialConfig(initConfig);
                documentIds = initConfig.documentIds, clientId = initConfig.clientId, version = initConfig.version, getFallbackTextsForLanguage = initConfig.getFallbackTextsForLanguage, fallback = initConfig.fallback;
                language = appConfig.language;
                _b.label = 1;
            case 1:
                _b.trys.push([1, 3, , 5]);
                return [4, fetchLanguageDocuments(documentIds, clientId, language, version)];
            case 2:
                document_1 = _b.sent();
                updateTranslations(document_1);
                return [3, 5];
            case 3:
                _b.sent();
                _a = updateTranslations;
                return [4, getFallbacks(language, getFallbackTextsForLanguage, fallback)];
            case 4:
                _a.apply(void 0, [_b.sent()]);
                return [3, 5];
            case 5: return [2];
        }
    });
}); };
var getFallbacks = function (language, getFallbackTextsForLanguage, fallback) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 3, , 4]);
                if (!getFallbackTextsForLanguage) return [3, 2];
                return [4, getFallbackTextsForLanguage(language)];
            case 1: return [2, _c.sent()];
            case 2: return [2, Promise.resolve((_a = fallback === null || fallback === void 0 ? void 0 : fallback[language]) !== null && _a !== void 0 ? _a : {})];
            case 3:
                _c.sent();
                return [2, Promise.resolve((_b = fallback === null || fallback === void 0 ? void 0 : fallback[language]) !== null && _b !== void 0 ? _b : {})];
            case 4: return [2];
        }
    });
}); };var hasMissingKey = function (options) {
    return Boolean(options && "onMissingKey" in options && options.onMissingKey !== undefined);
};
var hasInsert = function (options) {
    return Boolean(options && "insert" in options && options.insert !== undefined);
};var keyExistsForLanguage = function (key, translations, language) {
    var _a;
    var languageTranslations = (_a = translations === null || translations === void 0 ? void 0 : translations[language]) !== null && _a !== void 0 ? _a : {};
    return key in languageTranslations;
};var getFMSValue = function (key, translations, language) {
    return keyExistsForLanguage(key, translations, language)
        ? translations[language][key]
        : null;
};var insertValue = function (text, data) {
    return text.replace(/\{(.*?)\}/g, function (placeholder) {
        var value = data[placeholder.substring(1, placeholder.length - 1)];
        if (value !== null && value !== undefined) {
            return value.toString();
        }
        return "-";
    });
};var getText = function (key, options) {
    var emptyFallback = "??".concat(key, "??");
    var fmsValue = getFMSValue(key, currentTranslations, appConfig.language);
    if (fmsValue === null) {
        if (hasMissingKey(options)) {
            return options.onMissingKey();
        }
        return emptyFallback;
    }
    if (typeof fmsValue !== "string") {
        console.warn("".concat(key, " did not return as a string. To try and return an object,\n      use getJSON() instead."));
        return emptyFallback;
    }
    if (hasInsert(options)) {
        return insertValue(fmsValue, options.insert);
    }
    return fmsValue;
};var getJSON = function (key) {
    var emptyFallback = {};
    var fmsValue = getFMSValue(key, currentTranslations, appConfig.language);
    if (typeof fmsValue === "string") {
        console.warn("".concat(key, " returned as a string, use getText() instead"));
        return emptyFallback;
    }
    return fmsValue !== null && fmsValue !== void 0 ? fmsValue : emptyFallback;
};var getCurrentLanguage = function () { return appConfig.language; };var updateHtmlLang = function (language) { var _a; return (_a = document.getElementsByTagName("html")[0]) === null || _a === void 0 ? void 0 : _a.setAttribute("lang", language); };var sendNewLanguageToServer = function (newLanguage, currentLanguage) {
    var newCustomerLanguage = newLanguage === "en" ? "ENGLISH" : "NORWEGIAN";
    var oldCustomerLanguage = currentLanguage === "en" ? "ENGLISH" : "NORWEGIAN";
    if (newCustomerLanguage !== oldCustomerLanguage) {
        fetch("/customer/core-data", {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ language: newCustomerLanguage }),
        });
    }
};function getCookieDomain() {
    return process.env.NODE_ENV === "development"
        ? location.hostname
        : ".storebrand.no";
}
var setLanguageCookie = function (newLanguage, currentLanguage) {
    var newCustomerLanguage = newLanguage === "en" ? "ENGLISH" : "NORWEGIAN";
    var oldCustomerLanguage = currentLanguage === "en" ? "ENGLISH" : "NORWEGIAN";
    if (newCustomerLanguage !== oldCustomerLanguage) {
        Cookies.set("lang", newLanguage, {
            path: "/",
            domain: getCookieDomain(),
        });
    }
};var changeLanguage = function (language) { return __awaiter(void 0, void 0, void 0, function () {
    var currentLanguage, documentIds, clientId, newLanguage, version;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                currentLanguage = appConfig.language;
                setLanguageCookie(language, currentLanguage);
                updateHtmlLang(language);
                sendNewLanguageToServer(language, currentLanguage);
                setLanguage(language);
                documentIds = appConfig.documentIds, clientId = appConfig.clientId, newLanguage = appConfig.language, version = appConfig.version;
                if (!clientId) {
                    throw Error("No clientId was found in the config. Initialize your app with init()");
                }
                return [4, fetchLanguageDocuments(documentIds, clientId, newLanguage, version).then(function (document) { return updateTranslations(document); })];
            case 1:
                _a.sent();
                return [2];
        }
    });
}); };var updateFmsTranslations = function () { return __awaiter(void 0, void 0, void 0, function () {
    var documentIds, clientId, version, language, document;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                documentIds = appConfig.documentIds, clientId = appConfig.clientId, version = appConfig.version, language = appConfig.language;
                return [4, fetchLanguageDocuments(documentIds, clientId, language, version)];
            case 1:
                document = _a.sent();
                updateTranslations(document);
                return [2];
        }
    });
}); };exports.changeLanguage=changeLanguage;exports.fetchLanguageDocuments=fetchLanguageDocuments;exports.getCurrentLanguage=getCurrentLanguage;exports.getInitialLanguage=getInitialLanguage;exports.getJSON=getJSON;exports.getText=getText;exports.init=init;exports.setLanguageCookie=setLanguageCookie;exports.updateFmsTranslations=updateFmsTranslations;exports.updateHtmlLang=updateHtmlLang;//# sourceMappingURL=index.js.map
